<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">易耗品剩余汇总</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="耗材名称">
          <!-- <el-input v-model="formInline.name" clearable placeholder="请输入耗材名称"></el-input> -->
          <el-select v-model="formInline.name" style="width:216px;" filterable clearable placeholder="请选择实训耗材">
            <el-option v-for="item in $store.state.consumeIntos" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle=='导出中...'" @click="handleExportByUrl(formInline)">{{exportTitle}}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="number" label="编号" width="120">
        </custom-table-column>
        <custom-table-column fixed prop="name" label="易耗品名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" width="160">
        </custom-table-column>
        <custom-table-column prop="quantity" label="数量" width="120">
        </custom-table-column>
        <custom-table-column prop="remainder" label="库存数量" width="120">
        </custom-table-column>
        <custom-table-column prop="total_price" label="总价" width="180">
        </custom-table-column>
        <!-- <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column> -->
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="编号" prop="number">
          <el-input v-model="ruleForm.number" placeholder="请输入编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实训耗材名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入实训耗材名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="数  量" prop="quantity">
          <el-input v-model.number="ruleForm.quantity" placeholder="请输入数量" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="价  格" prop="price">
          <el-input v-model="ruleForm.price" placeholder="请输入价格" style="width:198px;"></el-input> 元
        </el-form-item>
        <el-form-item label="购买时间" prop="buy_at">
          <el-date-picker type="datetime" placeholder="选择购买时间" value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.buy_at" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="总  价" prop="total_price">
          <el-input v-model="total_price" :disabled="true" placeholder="请先输入数量和价格" style="width:198px;"></el-input> 元
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteTarinRoom">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      formInline: {
        name: '',
        training_room: '',
      },
      levell: [1, 2],
      ruleForm: {
        number: 0,
        name: '',
        quantity: 0,
        price: 0,
        total_price: 0,
      },
      downloadName:'实训耗材总账明细表.xlsx',
      rules: {
        number: [
          { required: true, message: '编号不能为空' },
          { type: 'number', message: '编号必须为数字值' },
        ],
        quantity: [
          { required: true, message: '数量不能为空' },
          { type: 'number', message: '数量必须为数字值' },
        ],
        price: [
          { required: true, message: '价格不能为空', trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        total_price: [
          { required: true, message: '总价不能为空' },
          { type: 'number', message: '总价必须为数字值' },
        ],
        name: [{ required: true, message: '请输入实训耗材名称', trigger: 'blur' }],
        buy_at: [{ type: 'date', required: true, message: '请选择购买时间', trigger: 'change' }],
      },
    };
  },
  created() {
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getConsum');
    this.exportUrl = `${this.baseUrlt}api/consume/remainder/queryExport`;
  },
  computed: {
    total_price() {
      // this.total_price = this.quantity*this.price
      return this.ruleForm.quantity * this.ruleForm.price;
    },
  },
  mounted() {},
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async deleteTarinRoom() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteConsumeInto(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createTarinRoom() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.total_price = this.total_price;
      let res = await this.$api.creat.createConsumeInto(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateTarinRoom() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.total_price = this.total_price;
      let res = await this.$api.update.updateTarinRoom(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.beforeQuery()
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getConsumeSurplusList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createTarinRoom();
          } else if (this.type == 'edit') {
            this.updateTarinRoom();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
